module.exports = __webpack_public_path__ + "static/how_it_works_multilayers_art-22c770aba619ad69d04813bcd1cc1dfc.png";